module.exports = __webpack_public_path__ + "static/media/06-_DSC0311.fb3789ba.jpg";